import { __assign, __rest } from "tslib";
// DS: PO28
/** Popup prompting users to verify their email address */
import React, { useContext, useCallback } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { FirstTimeFlag, } from '../redux/firstTimeFlags';
import VerificationPopupDesktop from './VerificationPopupDesktop';
import VerificationPopupMobile from './VerificationPopupMobile';
export var VerificationPopup = function (_a) {
    var dropFlagOnClose = _a.dropFlagOnClose, dropFirstTimeFlag = _a.dropFirstTimeFlag, onClose = _a.onClose, props = __rest(_a, ["dropFlagOnClose", "dropFirstTimeFlag", "onClose"]);
    var isMobile = useContext(MobileContext);
    var handleClose = useCallback(function () {
        if (dropFlagOnClose) {
            dropFirstTimeFlag({
                flag: FirstTimeFlag.WelcomePopupNotClosed,
            });
        }
        return onClose && onClose();
    }, [dropFlagOnClose, dropFirstTimeFlag, onClose]);
    return isMobile ? (React.createElement(VerificationPopupMobile, __assign({ onClose: handleClose }, props))) : (React.createElement(VerificationPopupDesktop, __assign({ onClose: handleClose }, props)));
};
VerificationPopup.displayName = 'VerificationPopup';
export default VerificationPopup;
//# sourceMappingURL=VerificationPopup.js.map